import { render } from "./BuyTicket.vue?vue&type=template&id=7bf6ee83&scoped=true"
import script from "./BuyTicket.vue?vue&type=script&lang=js"
export * from "./BuyTicket.vue?vue&type=script&lang=js"

import "./BuyTicket.vue?vue&type=style&index=0&id=7bf6ee83&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf6ee83"]])

export default __exports__